<script setup>
import { useMeeting } from '@/composables/useMeeting'
import { useAbility } from '@casl/vue'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Meeting',
  },
})

const ability = useAbility()
const router = useRouter()
const { meetings, loading, fetchMeetings } = useMeeting()

onMounted(() => fetchMeetings())

const statusColor = value => ({ scheduled: 'info', completed: 'success', cancelled: 'secondary' }[value] ?? 'secondary')

const headers = [
  { title: 'Judul', key: 'title' },
  { title: 'Unit', key: 'unit' },
  { title: 'Jadwal', key: 'scheduled_at' },
  { title: 'Status', key: 'status', align: 'center' },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <div class="d-flex align-center justify-space-between flex-wrap gap-3">
          <div>
            <h4 class="text-h4 font-weight-bold">
              Rapat Mutu
            </h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Agenda → Undangan → Daftar Hadir → Notulen → Tindak Lanjut (§9.6)
            </p>
          </div>
          <VBtn
            v-if="ability.can('create', 'Meeting')"
            prepend-icon="ri-add-line"
            @click="router.push({ name: 'meeting-create' })"
          >
            Jadwalkan Rapat
          </VBtn>
        </div>
      </VCol>
    </VRow>

    <VCard>
      <VDataTable
        :headers="headers"
        :items="meetings"
        :loading="loading"
        hide-default-footer
        @click:row="(e, { item }) => router.push({ name: 'meeting-id', params: { id: item.id } })"
      >
        <template #item.unit="{ item }">
          {{ item.unit?.name ?? '-' }}
        </template>
        <template #item.status="{ item }">
          <VChip
            size="small"
            :color="statusColor(item.status)"
            variant="tonal"
          >
            {{ item.status }}
          </VChip>
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              Belum ada rapat dijadwalkan
            </p>
          </div>
        </template>
      </VDataTable>
    </VCard>
  </div>
</template>
